import { render } from "./Chaier.vue?vue&type=template&id=25374268"
import script from "./Chaier.vue?vue&type=script&lang=js"
export * from "./Chaier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__